import {
    createVNode as _$cv,
    className as _$cn,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {getRestProps} from '../utils';
import {MediaGroupContext} from './context';
import {MediaViewer} from './viewer';
import {makeMediaGroupStyles, makeMediaViewerStyles} from './styles';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {
        getContextValue,
        isPreviewRendered,
        isPreviewVisible,
        getActiveViewerItem,
        getActiveIndex,
        getPreviewCount,
        hasPrev,
        hasNext,
        close,
        afterClose,
        prev,
        next,
    } = this.group;
    
    const {className, children} = this.get();
    const {k} = this.config;
    const classNameObj = {
        [`${k}-media-group`]: true,
        [className]: className,
        [makeMediaGroupStyles(k)]: true,
    };
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this)
    }, [
        _$cc(MediaGroupContext.Provider, {
            'value': getContextValue(),
            'children': children
        }),
        (isPreviewRendered() && getActiveViewerItem()) ?
            _$cc(MediaViewer, {
                'value': isPreviewVisible(),
                'item': getActiveViewerItem(),
                'index': getActiveIndex(),
                'total': getPreviewCount(),
                'hasPrev': hasPrev(),
                'hasNext': hasNext(),
                'container': this.get('container'),
                'onClose': close,
                'onAfterClose': afterClose,
                'onPrev': prev,
                'onNext': next,
                'className': _$cn(makeMediaViewerStyles(k))
            }) :
            undefined
    ]);
};